import Controller from "@ember/controller"
import { alias } from "@ember/object/computed"
import { inject as service } from "@ember/service"

export default class UserController extends Controller {
  queryParams = ["step", "afterSignInRedirectTo"]
  step = 1

  @service router

  @service
  session

  // Computed properties
  @alias("router.currentRouteName") currentPath
}
